/**
 * 用户发起维权
 * */
import React from 'react';
import { message } from 'antd';
import HTTP from '../../script/service';
import ComponentContent from './ComponentContent';

const PlayLegal = ({ visible, orderInfo, changeOrder, hideModal }) => {
  const handleSubmit = (value, callback = null) => {
    const params = {
      orderId: value.orderId,
      uid: value.uid,
      playQq: value.qq,
      playPhone: value.phone,
      playReason: value.reason,
      playReasonImg: value.reasonImg,
    };
    HTTP._add_appeal(params).then((res) => {
      if (res?.code === 200) {
        message.success('您已经提交维权资料，请耐心等待客服处理。');

        callback && callback();
        changeOrder && changeOrder();
      } else {
        message.error(res?.message || '操作失败，请稍后重试~');
      }
    });
  };

  return (
    <ComponentContent
      visible={visible}
      orderInfo={orderInfo}
      submit={handleSubmit}
      hideModal={hideModal}
    />
  );
};

export default PlayLegal;
